<template>
  <div class="main-view">
    <ApplicationHeaderPartialView />

    <div class="view-content collections-view">
      <div class="content-container">
        <div class="collections-section">
          <CollectionsTablePartialView
            v-if="
              settingsStore.collectionsViewEnabled &&
              settingsStore.viewMode === 'collections'
            "
          />
          <ServicesTablePartialView v-else />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ApplicationHeaderPartialView from "../components/partial-views/ApplicationHeaderPartialView.vue";
import CollectionsTablePartialView from "../components/partial-views/CollectionsTablePartialView.vue";
import ServicesTablePartialView from "../components/partial-views/ServicesTablePartialView.vue";
import { useSettingsStore } from "../stores/settingsStore.js";

const settingsStore = useSettingsStore();
</script>

<style>
.main-view {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
}

.main-view .view-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.main-view .collections-view {
  width: 100%;
}

.main-view .content-container {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
}

.main-view .collections-section {
  display: flex;
  flex-direction: column;
  overflow: auto;
  min-width: 0;
  background-color: #ffffff;
  padding: var(--app-space-6);
}

.main-view .non-commercial .fa-times {
  font-size: 1em;
}

.main-view .remove-collection:hover,
.main-view .btn:hover,
.main-view #select-all-label:hover {
  cursor: pointer;
}

/* Stack vertically on mobile */
@media (max-width: 768px) {
  .main-view .content-container {
    gap: var(--app-space-4);
    padding: var(--app-space-4);
  }

  .main-view .collections-section {
    min-height: 400px;
    padding: var(--app-space-4);
  }
}
</style>

